import { render, staticRenderFns } from "./ZCKQAllianceAuthorization.vue?vue&type=template&id=d2a5f408"
import script from "./ZCKQAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./ZCKQAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2a5f408')) {
      api.createRecord('d2a5f408', component.options)
    } else {
      api.reload('d2a5f408', component.options)
    }
    module.hot.accept("./ZCKQAllianceAuthorization.vue?vue&type=template&id=d2a5f408", function () {
      api.rerender('d2a5f408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/ZCKQAllianceAuthorization.vue"
export default component.exports